import { type CSSProperties } from 'react';
import { useAppDispatch, useAppSelector } from '../../store';
import { setViewMode, type DiffViewMode } from '@repancy/core';
import { testIds } from '../../lib/testIds';

const buttonBase: CSSProperties = {
  fontFamily: "var(--xp-font-body)",
  fontSize: 12,
  padding: '3px 10px',
  cursor: 'pointer',
  outline: 'none',
  minWidth: 80,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 4,
};

function makeButtonStyle(active: boolean): CSSProperties {
  return {
    ...buttonBase,
    backgroundColor: active ? '#ece9d8' : '#dfdfdf',
    border: '2px solid',
    borderColor: active
      ? '#808080 #dfdfdf #dfdfdf #808080'
      : '#dfdfdf #808080 #808080 #dfdfdf',
    color: '#000000',
    fontWeight: active ? 'bold' : 'normal',
  };
}

export function DiffToggle() {
  const dispatch = useAppDispatch();
  const viewMode = useAppSelector((s) => s.diff.viewMode);

  const handleClick = (mode: DiffViewMode) => {
    dispatch(setViewMode(mode));
  };

  const containerStyle: CSSProperties = {
    display: 'inline-flex',
    gap: 0,
  };

  return (
    <div style={containerStyle} data-testid={testIds.timeline.diffToggle}>
      <button
        style={makeButtonStyle(viewMode === 'side-by-side')}
        onClick={() => handleClick('side-by-side')}
        type="button"
        data-testid={testIds.timeline.diffSplit}
      >
        {'║'} Split
      </button>
      <button
        style={makeButtonStyle(viewMode === 'unified')}
        onClick={() => handleClick('unified')}
        type="button"
        data-testid={testIds.timeline.diffUnified}
      >
        {'▐'} Unified
      </button>
    </div>
  );
}
